export const UNITED_STATES_COUNTRY_ID = 1;

/** Intake Intl Donor column: non-US residence only (tax answered later on DS profile). */
export function hasForeignResidence(
    countryOfResidenceId: number | null | undefined,
    unitedStatesCountryId: number = UNITED_STATES_COUNTRY_ID
): boolean {
    return countryOfResidenceId != null
        && Number(countryOfResidenceId) > 0
        && Number(countryOfResidenceId) !== Number(unitedStatesCountryId);
}

export function computeIsInternationallyEligible(
    countryOfResidenceId: number | null | undefined,
    filesTaxesInUs: boolean | null | undefined,
    unitedStatesCountryId: number = UNITED_STATES_COUNTRY_ID
): boolean {
    if (!hasForeignResidence(countryOfResidenceId, unitedStatesCountryId)) {
        return false;
    }
    return filesTaxesInUs === false;
}
